import { useState } from 'react';
import { useMutation } from '@apollo/client';

import {
  CreateUploadDocument,
  CreateUploadMutation,
  UploadScope,
} from '@sandtech-hub-monorepo/ehub-client';
import { useErrorHandler } from './useErrorHandler';

export const useUploadFile = () => {
  const [uploadFileLoading, setUploadFileLoading] = useState(false);
  const [createUpload, { loading: createUploadLoading }] =
    useMutation(CreateUploadDocument);

  const { handleApolloError } = useErrorHandler();

  const uploadFile = async (scope: UploadScope, file: File) => {
    const { data } = await createUpload({
      variables: {
        input: { scope: scope, filename: file.name },
      },
      onError: handleApolloError,
      onCompleted: (data: CreateUploadMutation) => {},
    });

    if (data?.createUpload) {
      const formData = new FormData();
      data?.createUpload.fields.forEach(
        (kvPair: { key: string; value: string | Blob }) => {
          formData.append(kvPair.key, kvPair.value);
        }
      );

      formData.append('file', file);

      setUploadFileLoading(true);

      await fetch(data.createUpload.uploadUrl, {
        method: 'POST',
        body: formData,
      })
        // TODO: Fix CORS error on S3 urls
        .catch((e) => console.log(e));

      setUploadFileLoading(false);
    }

    return data?.createUpload.fileUrl;
  };

  return { uploadFile, loading: createUploadLoading || uploadFileLoading };
};
